mutation CreateUserFeedbackMutation($input: CreateFeedbackTicketInput!) {
  createFeedbackTicket(input: $input)
}
